
export const bsClasses = {
  container: `container-xl`,
}
